export const LANDING_PAGE_CONSTANTS = {
  STATES: 11,
  BRANCHES: 293,
  LIFETIME_CUSTOMERS: 19,
  EMPLOYEES: 1672,
  LAST_YEAR_DISBURSEMENT: 462.3,
  AUM: 518,
  DATA_EFFECTIVE_DATE: "Data as on 31st March 2026",
  DISTRICTS: 231,
  VILLAGES: 49000,
};
